import { render, staticRenderFns } from "./Manage-Product-Category.vue?vue&type=template&id=e1fc75e8&"
import script from "./Manage-Product-Category.vue?vue&type=script&lang=js&"
export * from "./Manage-Product-Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports